import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { Allowance, CreateAllowanceRequest, AllowanceStatus } from '../types';

export const allowanceService = {
  getByStatus: async (status: AllowanceStatus): Promise<Allowance[]> => {
    const response = await apiClient.get<Allowance[]>(
      API_ENDPOINTS.ALLOWANCES.BY_STATUS(status)
    );
    return response.data;
  },

  getByTrip: async (tripId: number): Promise<Allowance[]> => {
    const response = await apiClient.get<Allowance[]>(
      API_ENDPOINTS.ALLOWANCES.BY_TRIP(tripId)
    );
    return response.data;
  },

  create: async (data: CreateAllowanceRequest): Promise<Allowance> => {
    const response = await apiClient.post<Allowance>(
      API_ENDPOINTS.ALLOWANCES.BASE,
      data
    );
    return response.data;
  },

  approve: async (id: number): Promise<Allowance> => {
    const response = await apiClient.post<Allowance>(
      API_ENDPOINTS.ALLOWANCES.APPROVE(id)
    );
    return response.data;
  },

  reject: async (id: number, reason: string): Promise<Allowance> => {
    const response = await apiClient.post<Allowance>(
      API_ENDPOINTS.ALLOWANCES.REJECT(id),
      null,
      { params: { reason } }
    );
    return response.data;
  },
};
